module.exports = __webpack_public_path__ + "static/media/study 220214.2e2da79d.png";